"use client"

// Productlane nav marks, shared so the marketing site renders the same glyphs
// the dashboard does. Imported by apps/app via screens/app/nav-icons.
import { memo } from "react"
import {
	IconBookOpen4Fill18,
	IconStackPerspectiveFill18,
} from "nucleo-ui-fill-18"

interface NavIconProps {
	className?: string
	strokeWidth?: number | string
	size?: number | string
}

export const DocsIcon = memo(
	({ className, strokeWidth: _strokeWidth, size, ...props }: NavIconProps) => (
		<IconBookOpen4Fill18 size={size ?? 24} className={className} {...props} />
	),
)
DocsIcon.displayName = "DocsIcon"

export const CustomersIcon = memo(
	({ className, strokeWidth: _strokeWidth, size, ...props }: NavIconProps) => {
		const iconSize = size ?? 24
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={iconSize}
				height={iconSize}
				viewBox="0 0 12 12"
				fill="none"
				className={className}
				{...props}
			>
				<path
					d="M11.2372 9.75002H10.4998V4.50002C10.4998 4.30111 10.4208 4.11035 10.2802 3.96969C10.1395 3.82904 9.94876 3.75002 9.74985 3.75002H7.68735C7.63762 3.75002 7.58993 3.76978 7.55476 3.80494C7.5196 3.8401 7.49985 3.8878 7.49985 3.93752V9.75002H6.74985V1.51924C6.75109 1.40242 6.72574 1.28685 6.67571 1.18127C6.62568 1.0757 6.55229 0.982887 6.4611 0.909867C6.33679 0.812947 6.1851 0.757658 6.02758 0.751852C5.87005 0.746046 5.71471 0.790018 5.5836 0.877524L1.8336 3.37502C1.73073 3.44366 1.64642 3.53667 1.58819 3.64577C1.52996 3.75486 1.49961 3.87667 1.49985 4.00034V9.75002H0.762504C0.665597 9.74859 0.571743 9.78391 0.499822 9.84888C0.427901 9.91384 0.383249 10.0036 0.374847 10.1002C0.371441 10.1515 0.378619 10.2029 0.395933 10.2513C0.413248 10.2997 0.44033 10.3441 0.475497 10.3816C0.510664 10.4191 0.553166 10.4489 0.600362 10.4693C0.647558 10.4897 0.69844 10.5001 0.749847 10.5H11.2498C11.3013 10.5001 11.3521 10.4897 11.3993 10.4693C11.4465 10.4489 11.489 10.4191 11.5242 10.3816C11.5594 10.3441 11.5864 10.2997 11.6038 10.2513C11.6211 10.2029 11.6283 10.1515 11.6248 10.1002C11.6164 10.0036 11.5718 9.91384 11.4999 9.84888C11.428 9.78391 11.3341 9.74859 11.2372 9.75002ZM3.56235 8.62502C3.56246 8.67643 3.552 8.72731 3.53162 8.77451C3.51124 8.82171 3.48138 8.86421 3.44388 8.89937C3.40638 8.93454 3.36205 8.96162 3.31365 8.97894C3.26525 8.99625 3.2138 9.00343 3.1625 9.00002C3.06587 8.99162 2.97601 8.9469 2.91104 8.87488C2.84606 8.80286 2.8108 8.70889 2.81235 8.6119V7.88768C2.81103 7.7908 2.84638 7.69701 2.91133 7.62511C2.97627 7.55322 3.06599 7.50853 3.1625 7.50002C3.2138 7.49662 3.26525 7.5038 3.31365 7.52111C3.36205 7.53842 3.40638 7.56551 3.44388 7.60067C3.48138 7.63584 3.51124 7.67834 3.53162 7.72554C3.552 7.77273 3.56246 7.82362 3.56235 7.87502V8.62502ZM3.56235 6.00002C3.56246 6.05143 3.552 6.10231 3.53162 6.14951C3.51124 6.19671 3.48138 6.23921 3.44388 6.27437C3.40638 6.30954 3.36205 6.33662 3.31365 6.35394C3.26525 6.37125 3.2138 6.37843 3.1625 6.37502C3.06591 6.36651 2.97612 6.32176 2.91116 6.24976C2.84621 6.17776 2.81091 6.08386 2.81235 5.9869V5.26268C2.81103 5.1658 2.84638 5.07201 2.91133 5.00011C2.97627 4.92822 3.06599 4.88353 3.1625 4.87502C3.2138 4.87162 3.26525 4.8788 3.31365 4.89611C3.36205 4.91342 3.40638 4.94051 3.44388 4.97567C3.48138 5.01084 3.51124 5.05334 3.53162 5.10054C3.552 5.14773 3.56246 5.19862 3.56235 5.25002V6.00002ZM5.43735 8.62502C5.43746 8.67643 5.427 8.72731 5.40662 8.77451C5.38624 8.82171 5.35638 8.86421 5.31888 8.89937C5.28138 8.93454 5.23705 8.96162 5.18865 8.97894C5.14025 8.99625 5.0888 9.00343 5.0375 9.00002C4.94103 8.99163 4.85131 8.94704 4.78636 8.87522C4.72141 8.8034 4.68604 8.70966 4.68735 8.61284V7.88768C4.68615 7.79088 4.72156 7.69721 4.78649 7.62541C4.85142 7.55361 4.94107 7.509 5.0375 7.50049C5.0888 7.49709 5.14025 7.50426 5.18865 7.52158C5.23705 7.53889 5.28138 7.56598 5.31888 7.60114C5.35638 7.63631 5.38624 7.67881 5.40662 7.72601C5.427 7.7732 5.43746 7.82408 5.43735 7.87549V8.62502ZM5.43735 6.00002C5.43746 6.05143 5.427 6.10231 5.40662 6.14951C5.38624 6.19671 5.35638 6.23921 5.31888 6.27437C5.28138 6.30954 5.23705 6.33662 5.18865 6.35394C5.14025 6.37125 5.0888 6.37843 5.0375 6.37502C4.94107 6.36652 4.85142 6.3219 4.78649 6.25011C4.72156 6.17831 4.68615 6.08463 4.68735 5.98784V5.26268C4.68615 5.16588 4.72156 5.07221 4.78649 5.00041C4.85142 4.92861 4.94107 4.884 5.0375 4.87549C5.0888 4.87209 5.14025 4.87926 5.18865 4.89658C5.23705 4.91389 5.28138 4.94098 5.31888 4.97614C5.35638 5.01131 5.38624 5.05381 5.40662 5.10101C5.427 5.1482 5.43746 5.19908 5.43735 5.25049V6.00002Z"
					fill="currentColor"
				/>
			</svg>
		)
	},
)
CustomersIcon.displayName = "CustomersIcon"

export const InboxNavIcon = memo(
	({ className, size, ...props }: NavIconProps) => {
		const iconSize = size ?? 24
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={iconSize}
				height={iconSize}
				viewBox="0 0 17 17"
				fill="none"
				className={className}
				{...props}
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4.896 2.125C4.44145 2.12491 3.99886 2.27058 3.63321 2.54061C3.26756 2.81063 2.99814 3.19079 2.8645 3.62525L1.15671 9.17717C1.09435 9.37956 1.0626 9.59014 1.0625 9.80192V12.75C1.0625 13.3136 1.28638 13.8541 1.6849 14.2526C2.08341 14.6511 2.62391 14.875 3.1875 14.875H13.8125C14.3761 14.875 14.9166 14.6511 15.3151 14.2526C15.7136 13.8541 15.9375 13.3136 15.9375 12.75V9.80192C15.9375 9.59013 15.9056 9.37975 15.8433 9.17717L14.1348 3.62525C14.0012 3.19091 13.7319 2.81083 13.3664 2.54082C13.0009 2.2708 12.5584 2.12506 12.104 2.125H4.896ZM14.6873 9.03125L13.1197 3.93762C13.0529 3.7204 12.9182 3.53032 12.7354 3.3953C12.5526 3.26029 12.3313 3.18746 12.104 3.1875H4.896C4.66873 3.18746 4.44743 3.26029 4.2646 3.3953C4.08178 3.53032 3.94707 3.7204 3.88025 3.93762L2.31271 9.03125H4.32792C4.72261 9.03113 5.10954 9.14094 5.44534 9.34838C5.78113 9.55581 6.05252 9.85266 6.22908 10.2057L6.41042 10.569C6.4987 10.7455 6.63439 10.894 6.80229 10.9977C6.97019 11.1014 7.16365 11.1563 7.361 11.1562H9.64042C9.83784 11.1562 10.0314 11.1012 10.1993 10.9974C10.3672 10.8935 10.5028 10.745 10.591 10.5683L10.7723 10.2057C10.9489 9.85266 11.2203 9.55581 11.5561 9.34838C11.8919 9.14094 12.2788 9.03113 12.6735 9.03125H14.6873Z"
					fill="currentColor"
				/>
			</svg>
		)
	},
)
InboxNavIcon.displayName = "InboxNavIcon"

export const ChangelogIcon = memo(
	({ className, strokeWidth: _strokeWidth, size, ...props }: NavIconProps) => (
		<IconStackPerspectiveFill18
			size={size ?? 24}
			className={className}
			{...props}
		/>
	),
)
ChangelogIcon.displayName = "ChangelogIcon"

export const RequestsIcon = memo(
	({ className, strokeWidth: _strokeWidth, size, ...props }: NavIconProps) => {
		const iconSize = size ?? 24
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={iconSize}
				height={iconSize}
				viewBox="0 0 12 12"
				fill="none"
				className={className}
				{...props}
			>
				<path
					d="M11.52 2.68627L6.44308 0.106134C6.30743 0.0365169 6.15498 0 6 0C5.84502 0 5.69257 0.0365169 5.55692 0.106134L0.48 2.68735C0.335013 2.76103 0.213983 2.86952 0.129549 3.00148C0.0451155 3.13344 0.000375149 3.28404 0 3.43754V8.56246C0.000375149 8.71596 0.0451155 8.86656 0.129549 8.99852C0.213983 9.13048 0.335013 9.23897 0.48 9.31265L5.55692 11.8939C5.69257 11.9635 5.84502 12 6 12C6.15498 12 6.30743 11.9635 6.44308 11.8939L11.52 9.31265C11.665 9.23897 11.786 9.13048 11.8705 8.99852C11.9549 8.86656 11.9996 8.71596 12 8.56246V3.43808C11.9999 3.2843 11.9553 3.13337 11.8709 3.0011C11.7864 2.86883 11.6652 2.76009 11.52 2.68627ZM6 5.57185L1.36442 3.21409L6 0.856331L10.6356 3.21409L6 5.57185ZM6.46154 10.9111V6.31294L11.0769 3.96697V8.56246L6.46154 10.9111Z"
					fill="currentColor"
				/>
			</svg>
		)
	},
)
RequestsIcon.displayName = "RequestsIcon"

export const SortIcon = memo(
	({ className, strokeWidth: _strokeWidth, size, ...props }: NavIconProps) => {
		const iconSize = size ?? 24
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={iconSize}
				height={iconSize}
				viewBox="0 0 16 16"
				fill="none"
				className={className}
				{...props}
			>
				<path
					d="M2 10.6667L4.66667 13.3333L7.33333 10.6667"
					fill="currentColor"
				/>
				<path
					d="M7.33293 10.0417C7.58572 10.0417 7.81432 10.1939 7.91106 10.4274C8.00776 10.6609 7.95405 10.9303 7.77532 11.1091L5.10832 13.7751C4.86425 14.0191 4.46861 14.0191 4.22454 13.7751L1.55754 11.1091C1.37879 10.9303 1.32604 10.661 1.42278 10.4274C1.51956 10.194 1.7472 10.0417 1.99993 10.0417H7.33293ZM4.66594 12.4489L5.82415 11.2917H3.50969L4.66594 12.4489Z"
					fill="currentColor"
				/>
				<path
					d="M4.04175 13.3337V2.66667C4.04175 2.32149 4.32157 2.04167 4.66675 2.04167C5.01193 2.04167 5.29175 2.32149 5.29175 2.66667V13.3337C5.29157 13.6787 5.01182 13.9587 4.66675 13.9587C4.32168 13.9587 4.04192 13.6787 4.04175 13.3337Z"
					fill="currentColor"
				/>
				<path
					d="M14.0001 5.33334L11.3334 2.66667L8.66675 5.33334"
					fill="currentColor"
				/>
				<path
					d="M10.9899 2.1442C11.2323 1.98449 11.5616 2.01116 11.775 2.22428L14.442 4.89127C14.6208 5.07002 14.6745 5.33936 14.5778 5.57291C14.481 5.80634 14.2524 5.95865 13.9996 5.95865H8.66663C8.414 5.95865 8.18633 5.80621 8.08948 5.57291C7.99278 5.33944 8.04563 5.07002 8.22425 4.89127L10.8912 2.22428L10.9899 2.1442ZM10.1754 4.70865H12.4918L11.3326 3.55045L10.1754 4.70865Z"
					fill="currentColor"
				/>
				<path
					d="M10.7083 13.3337V2.66667C10.7083 2.32149 10.9881 2.04167 11.3333 2.04167C11.6784 2.04167 11.9583 2.32149 11.9583 2.66667V13.3337C11.9581 13.6787 11.6783 13.9587 11.3333 13.9587C10.9882 13.9587 10.7084 13.6787 10.7083 13.3337Z"
					fill="currentColor"
				/>
			</svg>
		)
	},
)
SortIcon.displayName = "SortIcon"

export const AdminIcon = memo(
	({ className, strokeWidth: _strokeWidth, size, ...props }: NavIconProps) => {
		const iconSize = size ?? 24
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={iconSize}
				height={iconSize}
				viewBox="0 0 24 24"
				fill="currentColor"
				className={className}
				aria-hidden="true"
				{...props}
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M8.25 6.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM15.75 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM2.25 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM6.31 15.117A6.745 6.745 0 0 1 12 12a6.745 6.745 0 0 1 6.709 7.498.75.75 0 0 1-.372.568A12.696 12.696 0 0 1 12 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 0 1-.372-.568 6.787 6.787 0 0 1 1.019-4.38Z"
				/>
				<path d="M5.082 14.254a8.287 8.287 0 0 0-1.308 5.135 9.687 9.687 0 0 1-1.764-.44l-.115-.04a.563.563 0 0 1-.373-.487l-.01-.121a3.75 3.75 0 0 1 3.57-4.047ZM20.226 19.389a8.287 8.287 0 0 0-1.308-5.135 3.75 3.75 0 0 1 3.57 4.047l-.01.121a.563.563 0 0 1-.373.486l-.115.04c-.567.2-1.156.349-1.764.441Z" />
			</svg>
		)
	},
)
AdminIcon.displayName = "AdminIcon"
